export const GET_STOCK_INWARDS = "GET_STOCK_INWARDS";
export const GET_STOCK_INWARD = "GET_STOCK_INWARD";
export const ADD_STOCK_INWARD = "ADD_STOCK_INWARD";
export const DELETE_STOCK_INWARD = "DELETE_STOCK_INWARD";
export const UPDATE_STOCK_INWARD = "UPDATE_STOCK_INWARD";
